'use client';

import { S } from './Html.styles';

export const HTML = S.HTML;
